import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@shared/components/ui/card";
import { cn } from "@shared/utils/cn";

export const DebugCard = ({ title = "", children, className = "" }) => {
  return (
    <Card className="select-text bg-black/5">
      <CardHeader className="pb-0">
        {title && (
          <CardTitle className="flex gap-2 text-lg items-center px-4 mb-4">
            {title}
          </CardTitle>
        )}
      </CardHeader>
      <CardContent className={cn("text-sm flex flex-col", className)}>
        {children}
      </CardContent>
    </Card>
  );
};
